import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import Select from "components/common/Select";
import FormAdvancedOptions from "./FormAdvancedOptions";
import INITIAL_FORMDATA from "./_initialFormData";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { pollingInterval } = formData;
  const availableContent = [
    { label: t("onepassword.subscribe.content_audit_events"), value: "AUDIT_EVENTS" },
    { label: t("onepassword.subscribe.content_item_usages"), value: "ITEM_USAGES" },
    { label: t("onepassword.subscribe.content_sign_in_attempts"), value: "SIGN_IN_ATTEMPTS" }
  ];
  const [contentTypes, setContentTypes] = useState(INITIAL_FORMDATA.availableContents.value);
  const [logTypeVal, setLogTypeVal] = useState(false);
  const handleSubmit = () => {
    if (pollingInterval.value >= 1) {
      setFormError(null);
      if (contentTypes.length === 0) {
        setLogTypeVal(true);
        return;
      }
      onSubmit();
    } else {
      setFormError({
        full_message: t("onepassword.subscribe.invalid_polling_interval_message"),
        nice_message: t("onepassword.subscribe.polling_interval_error")
      });
    }
    formData.contentTypes.value = contentTypes;
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.proceed"),
      title: "",
      className: "col-md-7",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement("label", { className: "control-label", htmlFor: "contentTypes" }, t("onepassword.subscribe.content_types")),
    /* @__PURE__ */ React.createElement(
      Select,
      {
        multi: true,
        name: "contentTypes",
        id: "contentTypes",
        onChange: (selected) => setContentTypes(selected),
        options: availableContent,
        value: contentTypes
      }
    ),
    logTypeVal && contentTypes.length === 0 && /* @__PURE__ */ React.createElement("label", { htmlFor: "contentTypes", style: { color: "red" } }, t("onepassword.subscribe.select_log_type")),
    /* @__PURE__ */ React.createElement("span", { className: "help-block" }, t("onepassword.subscribe.content_types_help")),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "pollingInterval",
        name: "pollingInterval",
        type: "number",
        value: pollingInterval.value || pollingInterval.defaultValue || "",
        min: "1",
        max: "60",
        step: "1",
        onChange,
        required: true,
        help: t("onepassword.subscribe.polling_interval_help"),
        label: t("onepassword.subscribe.polling_interval_label")
      }
    ),
    /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange })
  );
};
export default StepSubscribe;
